import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';
import { loadRuntimeConfig } from './environments/runtime-config';

// ── FullCalendar teardown guard ──────────────────────────────────────────────
// @fullcalendar/angular's OffscreenFragmentComponent.ngOnDestroy calls
// dummyContainer.removeChild(node) UNCONDITIONALLY. Angular 17+ detaches the DOM
// node during view teardown BEFORE that ngOnDestroy runs, so parentNode is no longer
// the container and removeChild throws:
//   "NotFoundError: Failed to execute 'removeChild' on 'Node': The node to be
//    removed is not a child of this node."
// The sibling TransportContainerComponent already guards this with a parentNode
// check; OffscreenFragmentComponent never got the same fix and it is STILL unguarded
// in every published version through 6.1.21 / 7.0.0 (fullcalendar/fullcalendar#8036),
// so there is no version to upgrade to. We make removeChild a no-op ONLY in that
// exact already-erroring case (the node isn't a child of `this`), which real code
// never hits — every legitimate removal runs unchanged.
const _removeChild = Node.prototype.removeChild;
Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
    if (child && child.parentNode !== this) {
        return child;
    }
    return _removeChild.call(this, child) as T;
} as typeof Node.prototype.removeChild;

// ── Runtime configuration ────────────────────────────────────────────────────
// config.json is fetched and merged into `environment` BEFORE the app bootstraps, so every
// service picks up the server's real API URLs when its constructor runs. This ordering is the
// whole mechanism — bootstrapping first would let services capture the baked defaults.
// A production build with no readable config.json refuses to boot rather than quietly pointing
// at localhost; see runtime-config.ts.
loadRuntimeConfig()
    .then(() => bootstrapApplication(AppComponent, appConfig))
    .catch((err) => console.error(err));
